// removed by extract-text-webpack-plugin
module.exports = {"social_gif":"social_gif__3-Gs-","countdownContainer":"countdownContainer__3GKYu","countdown":"countdown__2ljL7","unitWrapper":"unitWrapper__2WYLN","digit":"digit__1tHWl","unitLabel":"unitLabel__17Mhk","blue":"blue__3ma8t","darkfill":"darkfill__3V_-J","lightfill":"lightfill__3Tn9f","darkstroke":"darkstroke__Ih762","lightstroke":"lightstroke__2_JM1","red":"red__2iNQn","img":"img__hnGgZ","yellow":"yellow__34his","green":"green__1Py6t","img_fluid":"img_fluid__3AVoG"};


//////////////////
// WEBPACK FOOTER
// ./components/Countdown/style.css
// module id = mTzT
// module chunks = 0